import React from "react";
import { Hourglass } from "lucide-react";
import AppLayout, { PageHeader } from "../components/AppLayout";

export default function ComingSoonPage({ title, description }) {
  return (
    <AppLayout>
      <PageHeader title={title} breadcrumb={[{ label: "Norea", to: "/" }, title]} />
      <div className="bg-white border border-norea-border rounded-xl py-20 px-6 flex flex-col items-center text-center" data-testid="coming-soon">
        <div className="w-14 h-14 rounded-full bg-norea-primary/10 flex items-center justify-center mb-4">
          <Hourglass className="w-6 h-6 text-norea-primary" />
        </div>
        <h2 className="font-heading text-lg font-medium text-norea-text" data-testid="coming-soon-title">{title} — bientôt disponible</h2>
        <p className="mt-2 text-sm text-norea-textMuted max-w-md">{description || "Ce module est en préparation. Il apparaîtra ici dès qu'il sera prêt."}</p>
      </div>
    </AppLayout>
  );
}
